import React from 'react';
import CompatioApi from '../../api/CompatioApiXrsV3';
import EcommerceApi from '../../api/EcommerceApi';
import { FormattedMessage } from 'react-intl';
import Carousel from 'react-elastic-carousel';
import { assign as _assign, get as _get, forOwn as _forOwn } from 'lodash-es';
import _ from 'lodash-es';
import Product from '../product-card/Product';
import CompatioAnalytics from '../../api/CompatioAnalytics';
import { sorting } from '../utils/Constants';
import { sortProductList } from '../utils/HelperMethods';

class ProductList extends React.Component {
  /**
   * Track whether component is mounted
   *
   * @type {boolean}
   * @private
   */
  _isMounted = false;

  static defaultProps = {
    sorting: sorting,
    breakPoints: [
      { width: 1, itemsToShow: 2, itemsToScroll: 1 },
      { width: 450, itemsToShow: 3, itemsToScroll: 3 },
      { width: 750, itemsToShow: 4, itemsToScroll: 4 },
      { width: 850, itemsToShow: 5, itemsToScroll: 5 },
      { width: 1150, itemsToShow: 5, itemsToScroll: 5 },
      { width: 1450, itemsToShow: 5, itemsToScroll: 5 },
      { width: 1750, itemsToShow: 6, itemsToScroll: 6 },
    ],
    userId: CompatioAnalytics.getUserId(),
  };

  constructor(props) {
    super(props);
    // Merge default sort list with sort list from Compatio
    const mergedSorting = _assign(props.compatioSorting, props.sorting);
    const showAddtoCart = _get(
      window,
      'compatioConfig.compatibleProducts.showAddToCart'
    );
    let isReel = props.categoryName.toUpperCase();
    isReel = isReel === 'REELS';
    this.state = {
      sorting: mergedSorting,
      currentSortOrder: props.defaultSorting,
      currentProductsPerPage: props.productsPerPage,
      loading: true,
      errorMessage: null,
      products: {},
      variantOptions: [],
      IsPlatformShopify:
        typeof _get(window, 'compatioConfig.shopify') === 'object',
      showAddtoCart: showAddtoCart,
      isReel: isReel,
    };

    this.handleProductClick = this.handleProductClick.bind(this);
    this.setCompatioCategoryId(props.categoryId);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.defaultSorting !== this.props.defaultSorting) {
      CompatioAnalytics.track(
        CompatioAnalytics.events.xrsSortByChange,
        {
          baseFinalProductID: this.props.merchantProductSku,
          baseParentProductID: this.props.merchantProductId,
          baseFinalProductName: this.props.productName,
          categoryID: this.props.categoryId,
          categoryName: this.props.categoryName,
          categoryPosition: this.props.categoryPosition + 1,
          oldSortOrder: this.state.currentSortOrder,
          newSortOrder: this.props.defaultSorting,
        },
        'XRS',
        'V3'
      );
      // console.log(this.props);
      this.setState({
        currentSortOrder: this.props.defaultSorting,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * Retrieve products compatible with a specific category
   *
   * @param compatioCategoryId
   * @returns {Promise<void>}
   */

  async setCompatioCategoryId(compatioCategoryId) {
    try {
      const compatioCategoryData = await CompatioApi.getCategoryDataByProductSku(
        this.props.merchantProductSku,
        this.props.maximumCategories,
        this.props.maximumProducts
      );
      // console.log(
      //   compatioCategoryData,
      //   'compatioCategoryData',
      //   compatioCategoryId
      // );
      const selectedMerchantProductSkus = CompatioApi.extractProductSkusByCategoryId(
        compatioCategoryData,
        compatioCategoryId
      );

      // console.log(selectedMerchantProductSkus, 'selectedMerchantProductSkus');
      const eCommercePlatform =
        typeof _get(window, 'compatioConfig.shopify') === 'object'
          ? 'shopify'
          : '';
      const selectedProductData = await EcommerceApi.loadProductDataFromEcommerce(
        selectedMerchantProductSkus,
        eCommercePlatform,
        compatioCategoryData
      );

      // console.log(
      //   selectedProductData,
      //   'selectedProductData',
      //   compatioCategoryId
      // );
      // Don't set state if component has been unmounted (if user opens and closes category before API returns data)
      if (!this._isMounted) return;

      const mergedProductData = CompatioApi.mergeCompatioDataWithProductData(
        selectedProductData.data,
        compatioCategoryData,
        compatioCategoryId
      );
      // console.log(mergedProductData, 'mergedProductData');
      this.setState({
        products: mergedProductData,
        // variantOptions: selectedProductData.options,
        loading: false,
        errorMessage: null,
      });
    } catch (e) {
      // console.log('ee');
      console.error(e);
      if (!this._isMounted) return;
      this.setState({
        loading: false,
        errorMessage: (
          <FormattedMessage
            id="ProductList.error_loading"
            defaultMessage="Could not load product data"
          />
        ),
      });
    }
  }

  handleCarouselClick(currentPageIndex, clickDirection) {
    const div = document.querySelector('.xrs-container');
    const width = div.offsetWidth;
    let prodcutCountNumber = 2;
    if (width >= 982) {
      prodcutCountNumber = 5;
    } else if (width >= 848) {
      prodcutCountNumber = 4; // This will be applied if width is 750 or greater
    } else if (width >= 547) {
      prodcutCountNumber = 3; // This will be applied if width is between 450 and 749
    }
    CompatioAnalytics.track(
      CompatioAnalytics.events.xrsCarouselclick,
      {
        clickAction: clickDirection,
        currentPageIndex: currentPageIndex + 1,
        baseFinalProductID: this.props.merchantProductSku,
        baseParentProductID: this.props.merchantProductId,
        baseFinalProductName: this.props.productName,
        productsShownCount: prodcutCountNumber,
      },
      'XRS',
      'V3'
    );
  }

  handleProductClick(data) {
    CompatioAnalytics.track(
      CompatioAnalytics.events.xrsProductClick,
      {
        finalProductID: data.merchantProductId,
        parentProductID: data.merchantParentProductId,
        baseFinalProductName: this.props.productName,
        price: data.price,
        baseFinalProductID: this.props.merchantProductSku,
        baseParentProductID: this.props.merchantProductId,
        clickAction: CompatioAnalytics.clicks.xrsOpenProduct,
      },
      'XRS',
      'V3'
    );
    // console.log(this.props, 'this.props');
  }

  render() {
    const products = this.state.products;
    // console.log(products, 'productsproducts');
    if (this.state.loading)
      return (
        <h3 className="xrs-loading">
          <FormattedMessage
            id="ProductList.loading"
            defaultMessage="Loading products..."
          />
        </h3>
      );
    if (this.state.errorMessage)
      return <h3 className="xrs-error">{this.state.errorMessage}</h3>;
    if (!products.length)
      return (
        <h3 className="xrs-loading">
          <FormattedMessage
            id="ProductList.no_products"
            defaultMessage="This product option does not have any compatible {categoryName} available right now. Please select a different size or option to see compatible options"
            values={{ categoryName: this.props.categoryName }}
          />
        </h3>
      );

    let currentProductCount = 0;
    //   Sort products
    const sortedProducts = sortProductList(
      this.state.currentSortOrder,
      products
    );
    const CollapsedProducts = [];

    // previously working code for collapsing - this created issue for daves - so commented
    //let group = _.groupBy(sortedProducts, 'parentProductId');
    // _forOwn(group, (collapsedVariants, key) => {
    //   CollapsedProducts.push({ product: key, variants: collapsedVariants });
    // });

    // below logic added to fix sorting in daves - This logic is our custom code to collapse

    sortedProducts.forEach(element => {
      let ifExists = CollapsedProducts.find(
        each => each.product === element.parentProductId
      );
      if (ifExists === undefined)
        CollapsedProducts.push({
          product: element.parentProductId,
          variants: [element],
        });
      else {
        ifExists.variants.push(element);
      }
    });

    // Get specified "current" number of products
    const productList = (
      <Carousel
        breakPoints={this.props.breakPoints}
        pagination={false}
        onNextEnd={(nextItemObject, currentPageIndex) =>
          this.handleCarouselClick(
            currentPageIndex,
            CompatioAnalytics.clicks.xrsRightScroll
          )
        }
        onPrevEnd={(nextItemObject, currentPageIndex) =>
          this.handleCarouselClick(
            currentPageIndex,
            CompatioAnalytics.clicks.xrsLeftScroll
          )
        }
      >
        {CollapsedProducts.map(data => {
          return (
            <>
              <Product
                key={data.product}
                score={data.variants[0].compatioScore}
                productId={data.product}
                userId={this.props.userId}
                onClick={this.handleProductClick}
                data={data}
                sourceMerchantProductSku={this.props.merchantProductSku}
                sourceCompatioCategoryId={this.props.categoryId}
                productPosition={currentProductCount}
                categoryPosition={this.props.categoryPosition + 1}
                showAddtoCart={this.state.showAddtoCart}
                productName={this.props.productName}
                isReel={this.state.isReel}
                rootProductData={[
                  this.props.merchantProductId,
                  this.props.merchantProductSku,
                  this.props.productName,
                ]}
              />
            </>
          );
        })}
      </Carousel>
    );

    return (
      <div className="xrs-products">
        <div className="xrs-products__product-list">{productList}</div>
      </div>
    );
  }
}

export default ProductList;
